import Vue from 'vue';
import VueAMap from 'vue-amap';
import { AMapManager } from 'vue-amap';
Vue.use(VueAMap);
var sxamap={};
sxamap.install = function (Vue) {
	if (sxamap.installed) {
		return;
	}
	VueAMap.initAMapApiLoader({
	  key: '6b6c74688048e09d239c6c8523313f09',
	  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
	  v: '1.4.4'
	});
	Vue.prototype.VueAMap=VueAMap;
	Vue.prototype.AMapManager=AMapManager
	sxamap.installed=true;

}
export default sxamap;